import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: '12px 0'
  },
  row: {
    display: 'flex',
    // flexDirection
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: 8,
    gap: 24,
    maxWidth: 500
  },
  header: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subTitle: {
    color: theme.palette.grey[600],
    fontSize: 13,
    fontWeight: 500
  },
  input: {
    maxWidth: 320
  },
  bottom: {
    marginTop: 24,
    display: 'grid',
    gap: 16
  }
}))
export default useStyles
